import React from 'react'
import {connect} from 'react-redux'

import requestSignin from './data/actions/request_signin'
import setChatListToggled from './data/actions/set_chat_list_toggled'

import ProfileImage from '../shared/profile_image'
import PresenceIndicator from '../shared/presence_indicator'
import UserItemInfo from '../shared/user_item_info'
import CurrentUserSlidingMenu from '../shared/current_user_sliding_menu'

class ChatCurrentUserBar extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.onActionMenuClose = this.onActionMenuClose.bind(this)
    this.toggleActionMenu = this.toggleActionMenu.bind(this)
    this.requestSignin = this.requestSignin.bind(this)
  }

  toggleActionMenu () {
    this.setState({isActionMenuOpen: !this.state.isActionMenuOpen})
  }

  onActionMenuClose () {
    this.setState({isActionMenuOpen: false})
  }

  requestSignin (e) {
    if (e && e.preventDefault) e.preventDefault()

    this.props.setChatListToToggled(false)
    this.props.requestSignin()
  }

  renderSlidingMenu () {
    if (this.props.currentUser && this.props.currentUser.get('uid')) {
      return (
        <CurrentUserSlidingMenu
          top={42}
          isOpen={this.state.isActionMenuOpen}
          onActionMenuClose={this.onActionMenuClose} />
      )
    }
  }

  renderHelpButton () {
    return (
      <div className='action-menu-button help'>
        <a href={this.props.helpPageUrl} title='Go to Expert Chat Help & F.A.Q.' target='_blank' style={{textDecoration: 'none', fontSize: 'inherit', 'fontWeight': 'inherit', color: 'inherit'}}>
          <div style={{display: 'inline-block', width: 26, height: 26, lineHeight: '1.3em', borderRadius: 9999, border: '1px solid rgba(255, 255, 255, .8)'}}>
            &#63;
          </div>
        </a>
      </div>
    )
  }

  renderUserBar () {
    const user = this.props.currentUser.toJS()

    return (
      <div className='current-user-bar-container signed-in'>
        <ProfileImage user={user} image={user.profileImage} hasIndicator={false} size={24}/>
        <UserItemInfo user={user} className="primary" ratingEnabled={false} sessionsCountEnabled={false} usernameColor='#FFFFFF'/>
        <div className='actions'>
          <div className='action-menu-button' onClick={this.toggleActionMenu}>
            <PresenceIndicator user={user} />
            <i className='caret-icon rc-icon-caret-down' />
          </div>
          {this.renderHelpButton()}
        </div>
      </div>
    )
  }

  renderGuestBar () {
    return (
      <div className='current-user-bar-container guest'>
        <div className="guest-info">
          <i>{this.props.currentGuest.get('name')}</i>
        </div>
        <div className="actions">
          <button className='action-menu-button signin' onClick={this.requestSignin}>
            Sign in to chat
          </button>
          {this.renderHelpButton()}
        </div>
      </div>
    )
  }

  renderLoading () {
    return (
      <div className='current-user-bar-container guest'>
        <div className="guest-info">
          <i>Loading...</i>
        </div>
        <div className="actions">
        </div>
      </div>
    )
  }

  renderInnerContent () {
    if (this.props.currentUser && this.props.currentUser.get('uid')) return this.renderUserBar()
    else if (this.props.currentGuest) return this.renderGuestBar()
    else this.renderLoading()
  }

  render () {
    return (
      <div className='current-user-bar' style={{backgroundColor: this.props.currentUserBarBackground}}>
        {this.renderInnerContent()}
        {this.renderSlidingMenu()}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.get('currentUser'),
    currentGuest: state.get('currentGuest'),
    currentUserBarBackground: state.getIn(['chatSettings', 'colors', 'chatList']),
    helpPageUrl: state.getIn(['chatSettings', 'helpPageUrl'])
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    requestSignin: requestSignin,
    setChatListToToggled: (toggled) => dispatch(setChatListToggled(toggled))
  }
}

const ChatCurrentUserBarContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ChatCurrentUserBar)

export default ChatCurrentUserBarContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/chat_current_user_bar.js
 **/